// Tiny transient toast — shows a string at the bottom of the viewport for ~2s.
// Used as visible feedback for hotspot clicks so the operator can confirm what
// fired without opening devtools.

const DEFAULT_MS = 2200;

let rootEl: HTMLElement | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;

function ensureRoot(): HTMLElement {
  if (rootEl) return rootEl;
  const found = document.getElementById('toast');
  if (!found) throw new Error('[toast] #toast root element missing from DOM');
  rootEl = found;
  return rootEl;
}

export function showToast(message: string, opts: { ms?: number; tone?: 'info' | 'error' } = {}): void {
  const root = ensureRoot();
  root.textContent = message;
  root.dataset.tone = opts.tone ?? 'info';
  root.classList.add('is-visible');
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    root.classList.remove('is-visible');
    timer = null;
  }, opts.ms ?? DEFAULT_MS);
}
